import { DOCUMENT } from '@angular/common';
import { inject, makeEnvironmentProviders, NgZone, provideAppInitializer } from '@angular/core';
import { ConfigToken, raf } from '@ionic/angular/common';
import { ModalController, PopoverController } from '@ionic/angular/lazy';
import { setupConfig } from '@ionic/core';
import { setAssetPath as setIonicAssetPath } from '@ionic/core/components';
import { defineCustomElements } from '@ionic/core/loader';
import { setAssetPath as setIoniconsAssetPath } from 'ionicons/components';

/** IonicModule と standalone component が混在する間、lazy の要素も登録する。 */
export function provideLegacyIonicElements() {
  return makeEnvironmentProviders([
    ModalController,
    PopoverController,
    provideAppInitializer(() => {
      const doc = inject(DOCUMENT);
      const zone = inject(NgZone);
      const config = inject(ConfigToken);
      const win = doc.defaultView;
      if (!win) {
        return;
      }

      // 名前指定アイコンの SVG を、ビルドで配置されるアプリ基準の svg/ から読み込む。
      const resourcesUrl = new URL('.', doc.baseURI).href;
      setIonicAssetPath(resourcesUrl);
      setIoniconsAssetPath(resourcesUrl);

      // IonicModule.forRoot と同じ Zone.js 境界を保持する。
      setupConfig({ ...config, _zoneGate: (callback) => zone.run(callback) });
      const addEventListener = '__zone_symbol__addEventListener' in doc.body
        ? '__zone_symbol__addEventListener'
        : 'addEventListener';
      return defineCustomElements(win, {
        resourcesUrl,
        exclude: ['ion-tabs'],
        syncQueue: true,
        raf,
        jmp: (callback) => zone.runOutsideAngular(() => callback()),
        ael(element, eventName, callback, options) {
          (element as any)[addEventListener](eventName, callback, options);
        },
        rel(element, eventName, callback, options) {
          element.removeEventListener(eventName, callback, options);
        },
      });
    }),
  ]);
}
